export type ContestType = 'sorteo' | 'trivia' | 'comentarios' | 'compartir' | 'participacion';

export type ContestStatus = 'activo' | 'proximamente' | 'pausado' | 'finalizado';

export interface ContestParticipant {
  id: number;
  name: string;
  avatar: string;
  joinedAt: string;
  entry: string;
}

export interface Contest {
  id: number;
  title: string;
  description: string;
  prize: string;
  startDate: string;
  endDate: string;
  rules: string;
  type: ContestType;
  status: ContestStatus;
  stationId: number;
  participants: number;
  shares: number;
  published: boolean;
  winnerName?: string;
  winnerAvatar?: string;
  winnerPublished?: boolean;
}

export const contestTypeLabels: Record<ContestType, string> = {
  sorteo: 'Sorteo',
  trivia: 'Trivia',
  comentarios: 'Comentarios',
  compartir: 'Compartir',
  participacion: 'Participación',
};

export const contestTypeIcons: Record<ContestType, string> = {
  sorteo: 'ri-shining-line',
  trivia: 'ri-question-answer-line',
  comentarios: 'ri-chat-smile-2-line',
  compartir: 'ri-share-forward-line',
  participacion: 'ri-user-star-line',
};

export const contestTypeColors: Record<ContestType, { bg: string; text: string; border: string; bar: string }> = {
  sorteo:        { bg: 'bg-amber-50',    text: 'text-amber-700',    border: 'border-amber-300',   bar: 'bg-amber-400' },
  trivia:        { bg: 'bg-emerald-50',  text: 'text-emerald-700',  border: 'border-emerald-300', bar: 'bg-emerald-400' },
  comentarios:   { bg: 'bg-rose-50',     text: 'text-rose-700',     border: 'border-rose-300',    bar: 'bg-rose-400' },
  compartir:     { bg: 'bg-sky-50',      text: 'text-sky-700',      border: 'border-sky-300',     bar: 'bg-sky-400' },
  participacion: { bg: 'bg-violet-50',   text: 'text-violet-700',   border: 'border-violet-300',  bar: 'bg-violet-400' },
};

export const contestStatusLabels: Record<ContestStatus, string> = {
  activo: 'Activo',
  proximamente: 'Próximamente',
  pausado: 'Pausado',
  finalizado: 'Finalizado',
};

export const contestStatusColors: Record<ContestStatus, { dot: string; text: string; bg: string }> = {
  activo:       { dot: 'bg-emerald-500',    text: 'text-emerald-700',    bg: 'bg-emerald-50' },
  proximamente: { dot: 'bg-amber-500',      text: 'text-amber-700',      bg: 'bg-amber-50' },
  pausado:      { dot: 'bg-orange-500',     text: 'text-orange-700',     bg: 'bg-orange-50' },
  finalizado:   { dot: 'bg-foreground-400', text: 'text-foreground-500', bg: 'bg-foreground-100' },
};

export const mockParticipants: ContestParticipant[] = [
  { id: 1,  name: 'Lucía Fernández',  avatar: 'https://readdy.ai/api/search-image?query=Happy%20young%20Hispanic%20woman%20portrait%2C%20warm%20genuine%20smile%2C%20casual%20modern%20outfit%2C%20natural%20light%2C%20soft%20bokeh%20background%2C%20candid%20lifestyle%20portrait%20photography&width=80&height=80&seq=part-lucia&orientation=squarish',   joinedAt: '2026-06-06T10:30:00', entry: '¡Me encantaría conocer a Los Ecos! Son mi banda favorita desde hace años.' },
  { id: 2,  name: 'Diego Ramírez',    avatar: 'https://readdy.ai/api/search-image?query=Confident%20young%20Hispanic%20male%20portrait%2C%20friendly%20smile%2C%20casual%20streetwear%20style%2C%20urban%20background%20with%20warm%20sunset%20light%2C%20lifestyle%20portrait%20photography&width=80&height=80&seq=part-diego&orientation=squarish',     joinedAt: '2026-06-06T11:15:00', entry: 'Sueño con estar en el meet & greet. Los sigo desde su primer disco.' },
  { id: 3,  name: 'Marco Rivera',     avatar: 'https://readdy.ai/api/search-image?query=Warm%20friendly%20Hispanic%20male%20portrait%2C%20genuine%20smile%2C%20casual%20modern%20look%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20background%2C%20professional%20yet%20approachable%20headshot&width=80&height=80&seq=part-marco&orientation=squarish',    joinedAt: '2026-06-06T12:00:00', entry: 'Participando para el meet & greet. ¡Gracias Nueva Actitud!' },
  { id: 4,  name: 'Valentina Soto',   avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20young%20Hispanic%20female%20portrait%2C%20warm%20smile%2C%20casual%20chic%20outfit%2C%20golden%20hour%20light%2C%20soft%20urban%20background%2C%20lifestyle%20photography&width=80&height=80&seq=part-valentina&orientation=squarish',  joinedAt: '2026-06-07T09:20:00', entry: 'Quiero ganar esta rifa. Los Ecos son increíbles en vivo.' },
  { id: 5,  name: 'Andrés Morales',   avatar: 'https://readdy.ai/api/search-image?query=Kind%20Hispanic%20male%20portrait%2C%20thoughtful%20expression%2C%20casual%20modern%20style%2C%20clean%20studio%20lighting%2C%20warm%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=part-andres&orientation=squarish',   joinedAt: '2026-06-07T14:45:00', entry: 'Nunca gané nada en la radio. ¡Esta es la mía!' },
  { id: 6,  name: 'Camila Rojas',     avatar: 'https://readdy.ai/api/search-image?query=Cheerful%20young%20Hispanic%20female%20portrait%2C%20bright%20genuine%20smile%2C%20colorful%20blouse%2C%20natural%20daylight%2C%20soft%20urban%20background%2C%20joyful%20lifestyle%20photography&width=80&height=80&seq=part-camila&orientation=squarish',    joinedAt: '2026-06-08T08:10:00', entry: 'Adiviné 3 canciones esta semana. ¡Vamos por más!' },
  { id: 7,  name: 'Sebastián Gómez',  avatar: 'https://readdy.ai/api/search-image?query=Cool%20young%20Hispanic%20male%20portrait%2C%20confident%20yet%20friendly%20expression%2C%20modern%20streetwear%20style%2C%20natural%20light%2C%20urban%20background%2C%20authentic%20lifestyle%20photography&width=80&height=80&seq=part-sebastian&orientation=squarish', joinedAt: '2026-06-08T16:30:00', entry: 'Escucho el código todos los días. Hoy lo tengo.' },
  { id: 8,  name: 'Natalia Vega',     avatar: 'https://readdy.ai/api/search-image?query=Elegant%20young%20Hispanic%20female%20portrait%2C%20warm%20professional%20smile%2C%20modern%20business%20casual%2C%20soft%20studio%20light%2C%20clean%20background%2C%20polished%20headshot%20photography&width=80&height=80&seq=part-natalia&orientation=squarish',   joinedAt: '2026-06-09T07:00:00', entry: 'La música me salvó la vida. Este comentario es para eso.' },
  { id: 9,  name: 'Felipe Castillo',  avatar: 'https://readdy.ai/api/search-image?query=Charismatic%20Hispanic%20male%20portrait%2C%20friendly%20warm%20smile%2C%20casual%20modern%20attire%2C%20natural%20window%20light%2C%20relaxed%20lifestyle%20photography&width=80&height=80&seq=part-felipe&orientation=squarish',  joinedAt: '2026-06-09T18:20:00', entry: 'Mi dedicatoria es para mi hermana que está lejos. ¡Gracias!' },
  { id: 10, name: 'Sofía Mendoza',    avatar: 'https://readdy.ai/api/search-image?query=Joyful%20young%20Hispanic%20female%20portrait%2C%20radiant%20smile%2C%20colorful%20artistic%20background%2C%20creative%20fashion%20style%2C%20bright%20studio%20lighting%2C%20happy%20lifestyle%20photography&width=80&height=80&seq=part-sofia&orientation=squarish',   joinedAt: '2026-06-10T11:00:00', entry: 'Me encanta participar en los debates de Cabina.' },
  { id: 11, name: 'Mateo Gutiérrez',  avatar: 'https://readdy.ai/api/search-image?query=Young%20Hispanic%20male%20portrait%20with%20warm%20smile%2C%20casual%20hoodie%20style%2C%20natural%20afternoon%20light%2C%20relaxed%20outdoor%20urban%20setting%2C%20genuine%20lifestyle%20photography&width=80&height=80&seq=part-mateo&orientation=squarish',  joinedAt: '2026-06-10T13:45:00', entry: 'Siempre sintonizo Nueva Actitud. Ojalá gane esta vez.' },
  { id: 12, name: 'Isabella Díaz',    avatar: 'https://readdy.ai/api/search-image?query=Charming%20young%20Hispanic%20female%20portrait%2C%20sweet%20genuine%20smile%2C%20soft%20feminine%20style%2C%20dreamy%20bokeh%20background%2C%20warm%20golden%20light%2C%20ethereal%20lifestyle%20photography&width=80&height=80&seq=part-isabella&orientation=squarish',   joinedAt: '2026-06-11T09:00:00', entry: 'Participando por el parlante. ¡Sería el mejor regalo!' },
];

export const mockWinnerNames = [
  { name: 'Lucía Fernández',  avatar: 'https://readdy.ai/api/search-image?query=Happy%20young%20Hispanic%20woman%20portrait%2C%20warm%20genuine%20smile%2C%20casual%20modern%20outfit%2C%20natural%20light%2C%20soft%20bokeh%20background%2C%20candid%20lifestyle%20portrait%20photography&width=80&height=80&seq=winner-lucia&orientation=squarish' },
  { name: 'Diego Ramírez',    avatar: 'https://readdy.ai/api/search-image?query=Confident%20young%20Hispanic%20male%20portrait%2C%20friendly%20smile%2C%20casual%20streetwear%20style%2C%20urban%20background%20with%20warm%20sunset%20light%2C%20lifestyle%20portrait%20photography&width=80&height=80&seq=winner-diego&orientation=squarish' },
  { name: 'Marco Rivera',     avatar: 'https://readdy.ai/api/search-image?query=Warm%20friendly%20Hispanic%20male%20portrait%2C%20genuine%20smile%2C%20casual%20modern%20look%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20background%2C%20professional%20yet%20approachable%20headshot&width=80&height=80&seq=winner-marco&orientation=squarish' },
  { name: 'Valentina Soto',   avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20young%20Hispanic%20female%20portrait%2C%20warm%20smile%2C%20casual%20chic%20outfit%2C%20golden%20hour%20light%2C%20soft%20urban%20background%2C%20lifestyle%20photography&width=80&height=80&seq=winner-valentina&orientation=squarish' },
  { name: 'Camila Rojas',     avatar: 'https://readdy.ai/api/search-image?query=Cheerful%20young%20Hispanic%20female%20portrait%2C%20bright%20genuine%20smile%2C%20colorful%20blouse%2C%20natural%20daylight%2C%20soft%20urban%20background%2C%20joyful%20lifestyle%20photography&width=80&height=80&seq=winner-camila&orientation=squarish' },
  { name: 'Sebastián Gómez',  avatar: 'https://readdy.ai/api/search-image?query=Cool%20young%20Hispanic%20male%20portrait%2C%20confident%20yet%20friendly%20expression%2C%20modern%20streetwear%20style%2C%20natural%20light%2C%20urban%20background%2C%20authentic%20lifestyle%20photography&width=80&height=80&seq=winner-sebastian&orientation=squarish' },
  { name: 'Natalia Vega',     avatar: 'https://readdy.ai/api/search-image?query=Elegant%20young%20Hispanic%20female%20portrait%2C%20warm%20professional%20smile%2C%20modern%20business%20casual%2C%20soft%20studio%20light%2C%20clean%20background%2C%20polished%20headshot%20photography&width=80&height=80&seq=winner-natalia&orientation=squarish' },
  { name: 'Felipe Castillo',  avatar: 'https://readdy.ai/api/search-image?query=Charismatic%20Hispanic%20male%20portrait%2C%20friendly%20warm%20smile%2C%20casual%20modern%20attire%2C%20natural%20window%20light%2C%20relaxed%20lifestyle%20photography&width=80&height=80&seq=winner-felipe&orientation=squarish' },
];

export const adminContests: Contest[] = [
  {
    id: 1,
    title: 'Gana Meet & Greet con Los Ecos',
    description: 'Participá en nuestro sorteo especial y ganá un Meet & Greet exclusivo con la banda Los Ecos en su próxima visita a la cabina. Conocerás a los integrantes, te llevarás merch oficial firmada y una foto grupal.',
    prize: 'Meet & Greet + Merch oficial + Foto grupal',
    startDate: '2026-06-06',
    endDate: '2026-06-16',
    rules: '1. Ser mayor de 18 años. 2. Una participación por persona. 3. El ganador será anunciado el 16 de junio en vivo. 4. El premio no es transferible. 5. Debés estar disponible el día del evento.',
    type: 'sorteo',
    status: 'activo',
    stationId: 1,
    participants: 847,
    shares: 2341,
    published: true,
  },
  {
    id: 2,
    title: 'Trivia Matutina: Adiviná la Canción',
    description: 'Cada mañana Andrea pone 5 segundos de una canción. El primer oyente en adivinar el título y el artista gana una tarjeta de regalo de $50. Rápido, fácil y divertido.',
    prize: 'Tarjeta de regalo de $50',
    startDate: '2026-06-08',
    endDate: '2026-06-15',
    rules: '1. Participación vía Cabina o llamada telefónica. 2. Solo se acepta la primera respuesta correcta. 3. Una victoria por persona durante la semana.',
    type: 'trivia',
    status: 'activo',
    stationId: 1,
    participants: 234,
    shares: 567,
    published: true,
  },
  {
    id: 3,
    title: 'Sorteo del Código Secreto',
    description: 'Carlos menciona un código secreto al aire cada tarde durante Tardes de Pop. Anotalo y registralo en esta página. Al final de la semana sorteamos $100 entre todos los que tengan el código correcto.',
    prize: '$100 en efectivo',
    startDate: '2026-06-08',
    endDate: '2026-06-14',
    rules: '1. Escuchá el código al aire cada tarde. 2. Registralo aquí antes del domingo 14. 3. Solo códigos correctos participan. 4. El sorteo será en vivo el domingo a las 18h.',
    type: 'sorteo',
    status: 'pausado',
    stationId: 1,
    participants: 1256,
    shares: 3401,
    published: true,
  },
  {
    id: 4,
    title: 'Mejor Comentario de la Semana',
    description: 'Dejanos tu comentario más creativo sobre por qué amás la radio. El equipo elegirá al más original, divertido o emotivo. El ganador recibe una suscripción premium de 3 meses.',
    prize: 'Suscripción Premium 3 meses',
    startDate: '2026-06-01',
    endDate: '2026-06-12',
    rules: '1. Dejá tu comentario en la sección Comunidad. 2. Extensión máxima: 300 palabras. 3. Se valorará originalidad y creatividad. 4. El ganador se anunciará el 12 de junio.',
    type: 'comentarios',
    status: 'activo',
    stationId: 1,
    participants: 92,
    shares: 234,
    published: true,
  },
  {
    id: 5,
    title: 'Dedica y Ganá: Sorteo de Viernes',
    description: 'Mandá tu solicitud de canción con dedicatoria para el Viernes de Fiesta. Si tu canción suena al aire, entrás al sorteo de 2 entradas al Summer Fest.',
    prize: '2 entradas al Summer Fest',
    startDate: '2026-06-05',
    endDate: '2026-06-13',
    rules: '1. Enviá tu dedicatoria vía Cabina. 2. Incluí nombre de la canción y artista. 3. Las canciones deben ser aptas para todo público.',
    type: 'sorteo',
    status: 'activo',
    stationId: 1,
    participants: 310,
    shares: 876,
    published: true,
  },
  {
    id: 6,
    title: 'Sé Parte del Show: Invitado Especial',
    description: 'Participá activamente en la conversación de Cabina durante Tardes de Pop. El oyente más participativo de la semana será invitado a co-conducir un segmento de 15 minutos con Carlos en vivo.',
    prize: 'Co-conducción de 15 min en vivo',
    startDate: '2026-06-08',
    endDate: '2026-06-20',
    rules: '1. Participá en los debates de Cabina. 2. Sé respetuoso y constructivo. 3. El equipo elige al oyente más destacado. 4. Abierto a oyentes de cualquier ciudad.',
    type: 'participacion',
    status: 'activo',
    stationId: 1,
    participants: 189,
    shares: 432,
    published: true,
  },
  {
    id: 7,
    title: 'Gran Sorteo del Mes: Parlante Bluetooth',
    description: 'Sorteo mensual de Nueva Actitud. Participá para ganar un parlante Bluetooth JBL de alta fidelidad. Solo necesitás registrarte una vez. Mientras más interactuás con la radio, más chances tenés.',
    prize: 'Parlante Bluetooth JBL',
    startDate: '2026-06-01',
    endDate: '2026-06-30',
    rules: '1. Registro único por persona. 2. Mayor de 15 años. 3. El sorteo se realizará el 30 de junio en vivo. 4. Envío del premio a todo el país.',
    type: 'sorteo',
    status: 'activo',
    stationId: 1,
    participants: 2341,
    shares: 5678,
    published: true,
  },
  {
    id: 8,
    title: 'Trivia: Adiviná el Artista Sorpresa',
    description: 'El sábado 20 de junio tendremos un artista sorpresa en la cabina. Danos tu predicción del artista. Si acertás, ganás un backstage pass para conocerlo.',
    prize: 'Backstage Pass + Foto',
    startDate: '2026-06-15',
    endDate: '2026-06-20',
    rules: '1. Una predicción por persona. 2. Válido hasta las 12h del 20 de junio. 3. Si hay múltiples aciertos se sortea. 4. El artista será revelado en vivo.',
    type: 'trivia',
    status: 'proximamente',
    stationId: 1,
    participants: 0,
    shares: 89,
    published: false,
  },
  {
    id: 9,
    title: 'Comentá y Ganá: Playlist Perfecta',
    description: 'Armá tu playlist perfecta de 5 canciones y compartila en los comentarios. La playlist más votada por la comunidad gana y será transmitida completa un domingo.',
    prize: 'Playlist transmitida al aire',
    startDate: '2026-06-22',
    endDate: '2026-06-29',
    rules: '1. 5 canciones máximo. 2. Cualquier género. 3. Las canciones deben ser aptas para radio. 4. Votación abierta a toda la comunidad.',
    type: 'comentarios',
    status: 'proximamente',
    stationId: 1,
    participants: 0,
    shares: 45,
    published: false,
  },
  {
    id: 10,
    title: 'Sorteo Relámpago: Audífonos Pro',
    description: 'Sorteo sorpresa de media hora durante Despierta con Energía. Solo quienes estén en la Cabina en ese momento participan. Andrea anuncia el código y ¡a correr!',
    prize: 'Audífonos Profesionales',
    startDate: '2026-05-28',
    endDate: '2026-05-29',
    rules: '1. Solo participantes presentes en Cabina. 2. Código anunciado al aire. 3. Primera persona en registrarlo gana.',
    type: 'sorteo',
    status: 'finalizado',
    stationId: 1,
    participants: 64,
    shares: 189,
    published: true,
    winnerName: 'Lucía Fernández',
    winnerPublished: true,
    winnerAvatar: 'https://readdy.ai/api/search-image?query=Happy%20young%20Hispanic%20woman%20portrait%2C%20warm%20genuine%20smile%2C%20casual%20modern%20outfit%2C%20natural%20light%2C%20soft%20bokeh%20background%2C%20candid%20lifestyle%20portrait%20photography&width=80&height=80&seq=winner-lucia&orientation=squarish',
  },
  {
    id: 11,
    title: 'Sorteo de la Canción Más Pedida',
    description: 'Enviaste tu canción favorita durante mayo. Las 10 más pedidas entraron a sorteo y la comunidad eligió al ganador.',
    prize: 'Vinilo de colección + Playlist dedicada',
    startDate: '2026-05-01',
    endDate: '2026-05-31',
    rules: '1. Una canción por persona. 2. Cualquier género y década. 3. Votación abierta del 25 al 30 de mayo. 4. Anuncio en vivo el 31 de mayo.',
    type: 'sorteo',
    status: 'finalizado',
    stationId: 1,
    participants: 567,
    shares: 1345,
    published: true,
    winnerName: 'Diego Ramírez',
    winnerPublished: true,
    winnerAvatar: 'https://readdy.ai/api/search-image?query=Confident%20young%20Hispanic%20male%20portrait%2C%20friendly%20smile%2C%20casual%20streetwear%20style%2C%20urban%20background%20with%20warm%20sunset%20light%2C%20lifestyle%20portrait%20photography&width=80&height=80&seq=winner-diego&orientation=squarish',
  },
  {
    id: 12,
    title: 'Desafío: Maratón de Mensajes',
    description: 'Durante 24 horas seguidas, mandá la mayor cantidad de mensajes creativos a la Cabina. El más constante y original se lleva un kit de merch completo de la radio.',
    prize: 'Kit de merch completo',
    startDate: '2026-05-20',
    endDate: '2026-05-21',
    rules: '1. Participación única por persona. 2. Mensajes deben ser originales (no copiados). 3. Se valora calidad sobre cantidad. 4. No se permiten mensajes ofensivos.',
    type: 'participacion',
    status: 'finalizado',
    stationId: 1,
    participants: 178,
    shares: 456,
    published: true,
    winnerName: 'Marco Rivera',
    winnerPublished: false,
    winnerAvatar: 'https://readdy.ai/api/search-image?query=Warm%20friendly%20Hispanic%20male%20portrait%2C%20genuine%20smile%2C%20casual%20modern%20look%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20background%2C%20professional%20yet%20approachable%20headshot&width=80&height=80&seq=winner-marco&orientation=squarish',
  },
  {
    id: 13,
    title: 'Compartí y Ganá: Parlante Premium',
    description: 'Compartí nuestra publicación del concurso en tus redes sociales y participá en el sorteo de un parlante Bose de última generación. Cuantas más veces compartas con distintos amigos, más chances tenés de ganar.',
    prize: 'Parlante Bose SoundLink',
    startDate: '2026-06-10',
    endDate: '2026-06-25',
    rules: '1. Compartí la publicación del concurso en Facebook, X o WhatsApp. 2. Cada red social cuenta como una participación distinta. 3. Etiquetá a @NuevaActitudRadio.',
    type: 'compartir',
    status: 'activo',
    stationId: 1,
    participants: 456,
    shares: 2134,
    published: true,
  },
  {
    id: 14,
    title: 'Compartí la Foto del Verano',
    description: 'Compartí la foto oficial del Summer Fest de Nueva Actitud en tu historia de Instagram o estado de WhatsApp. Entre todos los que compartan sorteamos un pase VIP doble para el próximo festival.',
    prize: 'Pase VIP Doble + Meet & Greet',
    startDate: '2026-06-25',
    endDate: '2026-07-10',
    rules: '1. Compartí la imagen oficial en Instagram Stories o WhatsApp. 2. Mencioná a @NuevaActitudRadio. 3. Captura de pantalla como comprobante.',
    type: 'compartir',
    status: 'proximamente',
    stationId: 1,
    participants: 0,
    shares: 67,
    published: false,
  },
  {
    id: 15,
    title: 'Trivia Express: Bands de los 90s',
    description: 'Trivia rápida de 3 preguntas sobre bandas icónicas de los 90s. El primero en responder las 3 correctamente se lleva auriculares Sony profesionales.',
    prize: 'Auriculares Sony WH-1000XM5',
    startDate: '2026-05-15',
    endDate: '2026-05-16',
    rules: '1. 3 preguntas consecutivas al aire. 2. Primero en responder correctamente las 3 gana. 3. Una participación por persona.',
    type: 'trivia',
    status: 'finalizado',
    stationId: 1,
    participants: 145,
    shares: 367,
    published: true,
    winnerName: 'Valentina Soto',
    winnerPublished: true,
    winnerAvatar: 'https://readdy.ai/api/search-image?query=Beautiful%20young%20Hispanic%20female%20portrait%2C%20warm%20smile%2C%20casual%20chic%20outfit%2C%20golden%20hour%20light%2C%20soft%20urban%20background%2C%20lifestyle%20photography&width=80&height=80&seq=winner-valentina&orientation=squarish',
  },
  {
    id: 16,
    title: 'Compartí el Aftermovie del Festival',
    description: 'Compartí el aftermovie oficial del último festival en tus redes y participá por un pase all-access para el próximo evento. Incluye backstage, catering y zona VIP.',
    prize: 'Pase All-Access VIP',
    startDate: '2026-05-10',
    endDate: '2026-05-25',
    rules: '1. Compartí el video en al menos 2 redes sociales. 2. Usá el hashtag #NuevaActitudFest. 3. Etiquetá a 3 amigos. 4. Sorteo en vivo el 25 de mayo.',
    type: 'compartir',
    status: 'finalizado',
    stationId: 1,
    participants: 892,
    shares: 3456,
    published: true,
    winnerName: 'Sebastián Gómez',
    winnerPublished: true,
    winnerAvatar: 'https://readdy.ai/api/search-image?query=Cool%20young%20Hispanic%20male%20portrait%2C%20confident%20yet%20friendly%20expression%2C%20modern%20streetwear%20style%2C%20natural%20light%2C%20urban%20background%2C%20authentic%20lifestyle%20photography&width=80&height=80&seq=winner-sebastian&orientation=squarish',
  },
];

export function getStationContests(stationId: number): Contest[] {
  return adminContests.filter((c) => c.stationId === stationId);
}

export function getActiveContests(stationId: number): Contest[] {
  return getStationContests(stationId).filter((c) => c.status === 'activo');
}

export function getUpcomingContests(stationId: number): Contest[] {
  return getStationContests(stationId).filter((c) => c.status === 'proximamente');
}

export function getFinishedContests(stationId: number): Contest[] {
  return getStationContests(stationId).filter((c) => c.status === 'finalizado');
}

export function getContestParticipants(contestId: number): ContestParticipant[] {
  const count = adminContests.find((c) => c.id === contestId)?.participants || 0;
  return mockParticipants.slice(0, Math.min(count, mockParticipants.length));
}